<template>
  <component
    :is="to ? NuxtLink : 'button'"
    ref="menuButton"
    :to="to"
    :type="to ? undefined : 'button'"
    :class="computedButtonClasses"
    v-bind="attrs"
    @click="handleClick"
  >
    <span :class="computedIconClasses">
      <TIcon
        :icon="['fal', icon]"
        size="lg"
      />

      <span
        v-if="showBadge"
        class="absolute -top-1 -right-1 flex"
      >
        <AtomDot size="sm" />
      </span>
    </span>
    <span class="text-gray-500 leading-none">{{ text }}</span>
  </component>

  <TPopover
    v-if="$slots?.popover"
    ref="menuPopoverEl"
    placement="top"
  >
    <slot name="popover" />
  </TPopover>
</template>

<script setup lang="ts">
import { useTimeout } from '@vueuse/core'
import type { IconName } from '@fortawesome/fontawesome-svg-core'
import { NuxtLink } from '#components'

const props = defineProps<{
  to?: string
  icon: IconName
  text: string
  isActive?: boolean
  showBadge?: boolean
}>()

const emit = defineEmits<{
  click: [event: Event]
}>()

const attrs = useAttrs()

const menuButton = useTemplateRef('menuButton')
const menuPopoverEl = useTemplateRef('menuPopoverEl')

const slots = useSlots()
onMounted(() => {
  if (slots?.popover) {
    useTimeout(1000, {
      callback: () => {
        if (menuButton.value) {
          menuPopoverEl.value?.toggleShow(menuButton.value as HTMLElement)
        }
      },
    })
  }
})

function handleClick(event: Event) {
  if (menuPopoverEl.value) {
    menuPopoverEl.value.hide()
  }
  emit('click', event)
}

const computedButtonClasses = computed(() => {
  return [
    'flex flex-col gap-1 items-center justify-center size-16 text-xs/6 sm:text-sm/6 cursor-pointer',
    {
      'text-gray-700': !props.isActive,
      'fill-secondary': props.isActive,
    },
  ]
})

const computedIconClasses = computed(() => {
  return [
    'relative',
    {
      'text-secondary': props.isActive,
    },
  ]
})
</script>
